import { OutlineElement } from '../../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import componentStyles from './ghs-about-me-table.css.lit';
import { SlotController } from '../../../controllers/slot-controller';

/**
 *
 * @elementsList - this is a list of all elements and attributes, surveyed from Figma.
 * -title - always present, string.
 * -rows - always present, string.
 *
 * @orderedElementsList - this is a list of all elements, with their order pieced together, from Figma.
 *    title
 *      heading
 *    rows
 *      p tags representing left and right side of the table
 */

/**
 * The GHS About Me Table component
 * @element ghs-about-me-table
 * @slot - about-me-table-title, title of the slice.
 * @slot - about-me-table-rows - content in rows.

 */
@customElement('ghs-about-me-table')
export class GhsAboutMeTable extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  @state() hasTitleSlot: boolean;
  @state() hasRowsSlot: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasTitleSlot = this.slots.test('about-me-table-title') !== null;
    this.hasRowsSlot = this.slots.test('about-me-table-rows') !== null;
  }
  render(): TemplateResult {
    return html`
      <div class="about-me-table-wrapper">
        ${this.hasTitleSlot
          ? html`
              <ghs-heading
                level="h3"
                level-size="3xl"
                level-style="semibold"
                class="about-me-heading"
                site=${this.site}
              >
                <slot name="about-me-table-title"></slot>
              </ghs-heading>
            `
          : nothing}
        ${this.hasRowsSlot
          ? html`
              <div class="about-me-text">
                <slot name="about-me-table-rows"></slot>
              </div>
            `
          : nothing}
      </div>
    `;
  }
}
